import './FormatEditor.scss'
export const ErrorMessage = ({ message }: { message?: string }) => {
  if (!message) {
    return <></>
  }
  return <span className="c-format-editor__error">{message}</span>
}
